package playground.gradient.data

import androidx.compose.ui.graphics.Color
import kotlin.random.Random

data class ColorStop(
    var stop: Float,
    val color: Color,
    val id: Long = Random.nextLong()
)